module.exports = __webpack_public_path__ + "static/media/masonry_4.4e32e632.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/textures/masonry_4.jpg
// module id = 1133
// module chunks = 0